// Legacy serialization includes non camelcase properties
/* eslint-disable camelcase */
import Immutable from 'immutable'
import moment from 'moment'

import createStorableCard from './StorableCard'

export const PaymentTokenRecord = Immutable.Record({
  card: null,
  clientId: null,
  dateAdded: null,
  dateUpdated: null,
  date_disabled: null,
  failures: 0,
  state: '',
  uuid: '',
}, 'PaymentToken')

export default function createPaymentToken({
  card,
  dateAdded,
  dateUpdated,
  date_disabled,
  ...data
}) {
  return new PaymentTokenRecord({
    ...data,
    card: card ? createStorableCard(card) : null,
    dateAdded: dateAdded ? moment(dateAdded) : null,
    dateUpdated: dateUpdated ? moment(dateUpdated) : null,
    date_disabled: date_disabled ? moment(date_disabled) : null,
  })
}

export function filterToken(token, filter) {
  let match = false

  if (typeof filter.clientId !== 'undefined') {
    match = match || token.clientId === filter.clientId
  }

  if (typeof filter.tokenUuid !== 'undefined') {
    match = match || token.uuid === filter.tokenUuid
  }

  return match
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/PaymentToken.js